import React from "react";
import Loadable from "../../react-loadable";

const WeaFieldTemplateSelect = Loadable({
  loader: () => import("./FieldTemplateSelect"),
  loading: () => null,
  render: (obj, props, ref) => {
    if (obj) {
      return React.createElement(obj && obj.__esModule ? obj.default : obj, {
        ...props,
        ref
      });
    }
    return null;
  }
});

export default WeaFieldTemplateSelect;



// WEBPACK FOOTER //
// ./ecology9/wea-field-template-select/index.js